import { get, post, put, del } from '@/services/http';

export class OAClientModel {
  public clientId: string;
  public clientSecret?: string;
  public name: string;
  public redirectUris: string[];
  public grantTypes: string[];
  public status?: string;
  public createdAt?: string;
  public updatedAt?: string;

  constructor(data: any = {}) {
    this.clientId = data.clientId;
    this.name = data.clientName;
    this.redirectUris = data.redirectUris || [];
    this.grantTypes = data.grantTypes || ['authorization_code', 'refresh_token'];
  }

  public async save() {
    const payload = {
      clientName: this.name,
      redirectUris: this.redirectUris,
      grantTypes: this.grantTypes,
    };

    let res: any;
    if (this.clientId) {
      res = await put(`/oauth-clients/${this.clientId}`, payload);
    } else {
      res = await post('/oauth-clients', payload);
    }

    this.mapData(res);
  }

  public async delete() {
    await del(`/oauth-clients/${this.clientId}`);
  }

  public mapData(data: any = {}) {
    this.clientId = data.clientId;
    this.name = data.clientName;
    this.clientSecret = data.clientSecret;
    this.redirectUris = data.redirectUris;
    this.grantTypes = data.grantTypes;
    this.status = data.status;
    this.createdAt = data.createdAt;
    this.updatedAt = data.updatedAt;
  }

  public async fetch() {
    const res: any = await get(`/oauth-clients/${this.clientId}`);
    this.mapData(res);
  }
}